import { getDocuments } from '../services/documents';
import { TIMEZONE_GMT } from '../services/request';
import { cardsChartNormalizerProps } from '../utils/normalizers/homeIndicators';

const getAllStats = async (
  fromDate,
  toDate,
): Promise<cardsChartNormalizerProps | any> => {
  const data = getDocuments(
    `stats/sums?fromDate=${fromDate}&toDate=${toDate}&timeZone=${TIMEZONE_GMT}`,
  );
  return data;
};

const getEnergyStats: any = (fromDate, toDate) => {
  return getDocuments(
    `stats/energy?fromDate=${fromDate}&toDate=${toDate}&timeZone=${TIMEZONE_GMT}`,
  );
};

const getEnvironStats: any = (fromDate, toDate) => {
  return getDocuments(
    `stats/environ_indicator?fromDate=${fromDate}&toDate=${toDate}&timeZone=${TIMEZONE_GMT}`,
  );
};

const getCostStats: any = (fromDate, toDate) => {
  return getDocuments(
    `stats/cost?fromDate=${fromDate}&toDate=${toDate}&timeZone=${TIMEZONE_GMT}`,
  );
};

const getIncomeStats: any = (fromDate, toDate) => {
  return getDocuments(
    `stats/income?fromDate=${fromDate}&toDate=${toDate}&timeZone=${TIMEZONE_GMT}`,
  );
};

const getInfoStats: any = (fromDate, toDate) => {
  return getDocuments(
    `stats/info?fromDate=${fromDate}&toDate=${toDate}&timeZone=${TIMEZONE_GMT}`,
  );
};

const getChartsData = async (
  days: string,
  stationId: string,
  userId: string,
): Promise<cardsChartNormalizerProps | any> => {
  const timeDiffFromUTC = -(new Date().getTimezoneOffset() / 60);
  return getDocuments(
    `stations/dashboard/graphs?days=${days}&stationId=${stationId}&userId=${userId}&timeDiff=${timeDiffFromUTC}`,
  );
};

export {
  getAllStats,
  getChartsData,
  getEnergyStats,
  getEnvironStats,
  getCostStats,
  getIncomeStats,
  getInfoStats,
};
